import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { TextStyled } from 'petco-ui/elements/text/paragraph/Text.styled';

const modifiers = {
  regular: ({ theme }) => ({
    styles: `
      font-size: 1rem;
      color: ${theme.primary.text};
    `,
  }),
  light: ({ theme }) => ({
    styles: `
      color: ${theme.primary.darkGray};
      font-size: 1rem;
    `,
  }),
  header: ({ theme }) => ({
    styles: `
      color: ${theme.primary.text};
      font-weight: 700;
      font-size: 1.125rem;
    `,
  }),
  alert: ({ theme }) => ({
    styles: `
      color: ${theme.status.info.main};
      font-weight: 700;
      font-size: 0.75rem;
    `,
  }),
  help: ({ theme }) => ({
    styles: `
      color: ${theme.primary.main};
      font-weight: 400;
      font-size: 0.75rem;
    `,
  }),
  inverted: ({ theme }) => ({
    styles: `
      color: ${theme.primary.contrastText};
    `,
  }),
  caption: () => ({
    styles: `
      font-size: 0.6875rem;
      line-height: 1.5;
    `,
  }),
  uppercase: () => ({
    styles: `
      text-transform: uppercase;
    `,
  }),
  strong: () => ({
    styles: `
      font-weight: bold;
    `,
  }),
  center: () => ({
    styles: `
     text-align: center;
    `,
  }),
  small: () => ({
    styles: `
     font-size: 0.875rem;
     line-height: 1.25rem;
    `,
  }),
};

const Text = styled(TextStyled).attrs({
  className: 'Text',
})`
  ${applyStyleModifiers(modifiers)};
`;

export default Text;
